// 导入单个组件
// clxx
import ClglClxxTransferForm from './src/clxx/components/TransferForm'
import ClglClxxList from './src/clxx/list'

// pcgl
import ClglPcgl from './src/pcgl/index'

// portlet
import ClglOfficialVehicles from './src/portlet/OfficialVehicles'
import ClglVehicleList from './src/portlet/vehicleList'
import ClglVehicleRegistration from './src/portlet/vehicleRegistration'
import ClglYcjl from './src/portlet/ycjl'

// tjbb
import ClglTjbbDwyc from './src/tjbb/dwyc/index'
import ClglTjbbJykcz from './src/tjbb/jykcz/index'
import ClglTjbbJykxf from './src/tjbb/jykxf/index'
import ClglTjbbSjyc from './src/tjbb/sjyc/index'
import ClglTjbbSjycOld from './src/tjbb/sjyc/indexOld'
import ClglTjbbWxfy from './src/tjbb/wxfy/index'

// wdpc
import ClglWdpc from './src/wdpc/index'

// 以数组的结构保存组件，便于遍历
const components = {
    ClglClxxTransferForm,
    ClglClxxList,
    ClglPcgl,
    ClglOfficialVehicles,
    ClglVehicleList,
    ClglVehicleRegistration,
    ClglYcjl,
    ClglTjbbDwyc,
    ClglTjbbJykcz,
    ClglTjbbJykxf,
    ClglTjbbSjyc,
    ClglTjbbSjycOld,
    ClglTjbbWxfy,
    ClglWdpc
}
// 定义 install 方法
const install = function(Vue) {
    if (install.installed) return
    install.installed = true
    // 遍历并注册全局组件
    Object.keys(components).forEach(key => {
        Vue.component(key, components[key])
    })
}

if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue)
}
const $messages = require('./lang/index')

export default {
    // 导出的对象必须具备一个 install 方法
    install,
    // 组件列表
    ...components,
    $messages

}
